<template>
    <ion-page>
        <ion-header :translucent="true">
            <ion-toolbar>
                <ion-buttons slot="start">
                    <ion-menu-button color="primary"></ion-menu-button>
                </ion-buttons>
                <ion-title>My GPS Device</ion-title>
                <ion-buttons id="click-trigger33" slot="end" class="ion-padding" @click="openPopover($event)">
                    <ion-icon :ios="ellipsisVerticalOutline" :md="ellipsisVertical"></ion-icon>
                </ion-buttons>
                <ion-popover :is-open="popoverOpen" :event="event" @didDismiss="popoverOpen = false" >
                    <ion-content class="ion-text-center">
                        <ion-list>
                            <ion-item button="true" @click="transfer" detail="false">Transfer</ion-item>
                        </ion-list>
                    </ion-content>
                </ion-popover>
            </ion-toolbar>
        </ion-header>

        <ion-content :fullscreen="true">
            <ion-header collapse="condense">
                <ion-toolbar>
                    <ion-title size="large">My GPS Device</ion-title>
                </ion-toolbar>
            </ion-header>
            <!-- <div style="margin:10px">
                <ion-button @click="transfer">Transfer</ion-button>
                
            </div> -->
            
            
            <div id="container">
                 <!-- <ion-searchbar v-model="searchData" type="number" 
                            animated 
                            show-cancel-button="never" 
                            show-clear-button="never" 
                            @keyup="cancelSearch()"
                            @keypress.enter="loadData(pageCount,searchData)"></ion-searchbar> -->

                    <ion-grid>
                        <ion-row>
                            <ion-col>
                                <ion-item>
                                <ion-label position="floating">Device Id </ion-label>
                                <ion-input type="number" v-model="searchData['deviceId']" @keyup="cancelSearch()"></ion-input>
                            </ion-item>
                            </ion-col>
                            <ion-col>
                                <ion-item>
                                <ion-label position="floating">Device Serial</ion-label>
                                <ion-input v-model="searchData['deviceSerial']" @keyup="cancelSearch()"></ion-input>
                            </ion-item>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <ion-button expand="block" fill="outline" shape="round" @click="loadData(pageCount,searchData)">Search</ion-button>
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                    
                
                <DataTable :loading="loading" editMode="cell" v-model:selection="selectedDevices" dataKey="serial"
                    :metaKeySelection="false" class="p-datatable-sm" showGridlines :value="gpsDevices" :lazy="true"
                    :paginator="true" :rows="perPage" :totalRecords="total" @page="onPage($event)"
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                    responsiveLayout="scroll" :rowClass="data=>{ return 'dataRow'}" :stripedRows="true">
                    <template #loading>
                        Loading data, please wait...
                    </template>
                    <template #empty>
                        No records found
                    </template>
                    <Column selectionMode="multiple" headerStyle="width: 3em">
                    </Column>
                    <Column field="id" header="ID"></Column>
                    <Column field="status" header="Status">
                        <template #editor="{data}">
                            <Dropdown @change="changeStatus($event,data.id)" v-model="data.status"
                                :options="statusOptions" placeholder="Select a Status">
                            </Dropdown>
                        </template>
                        <template #body="{data}">
                            {{data.status}}
                        </template>
                    </Column>
                    <Column field="serial" header="Serial"></Column>
                    <Column field="sims" header="Mobile">
                        <template #body="{data}">
                            <div v-html="data.sims"></div>
                        </template>
                    </Column>
                    <Column field="imei" header="IMEI">
                        <template #body="{data}">
                            <div v-html="data.imei"></div>
                        </template>
                    </Column>
                    <Column field="version" header="Version"></Column>
                    <Column field="gpsCompany" header="Company"></Column>
                    <Column field="createdBy" header="Created By"></Column>
                    <!-- <Column field="updatedBy" header="Updated By">
                        <template #body="{data}">
                            <div v-html="data.details"></div>
                        </template>
                    </Column> -->
                </DataTable>
            </div>
        </ion-content>
    </ion-page>
</template>

<script>
    import {
        IonButtons,
        IonContent,
        IonHeader,
        IonMenuButton,
        IonPage,
        IonTitle,
        IonToolbar,
        IonButton,
        IonIcon,
        IonPopover,
        IonList,
        IonItem,
        IonLabel,
        IonInput,
        IonGrid,
        IonRow,
        IonCol,
        IonSearchbar,
        IonAccordionGroup,
        IonAccordion,
        alertController,

    } from '@ionic/vue';
    import {
        defineComponent
    } from 'vue';
    import DataTable from 'primevue/datatable';
    import Column from 'primevue/column';
    import Dropdown from 'primevue/dropdown';
    import Accordion from 'primevue/accordion';
    import AccordionTab from 'primevue/accordiontab';
    import {
        ellipsisVertical,
        ellipsisVerticalOutline,
    } from "ionicons/icons";

    export default defineComponent({
        name: 'My Device',
        components: {
            IonButtons,
            IonContent,
            IonHeader,
            IonMenuButton,
            IonPage,
            IonTitle,
            IonToolbar,
            IonButton,
            DataTable,
            Column,
            Dropdown,
            IonIcon,
            IonPopover,
            IonList,
            IonItem,
            IonGrid,
            IonRow,
            IonCol,
            // IonSearchbar,
            IonLabel,
            IonInput,
            // IonAccordionGroup,
            // IonAccordion,
            // Accordion,
            // AccordionTab
        },
        data() {
            return {
                statusOptions: [
                    'Good',
                    'Faulty',
                    'Lost',
                    'Damaged',
                    'Dead'
                ],
                selectedDevices: [],
                gpsDevices: [],
                loading: false,
                perPage: 20,
                total: 0,
                pageCount:0,
                searchData: {
                    deviceId:null,
                    deviceSerial:null,
                },
                popoverOpen: false,
                event: null,
                ellipsisVertical,
                ellipsisVerticalOutline,
            }
        },
        mounted() {
            this.loadData(this.pageCount,this.searchData);
        },
        methods: {
            async presentResponseAlert(type, message) {
                const alert = await alertController
                    .create({
                        header: type + '!',
                        // subHeader: 'Subtitle',
                        message: message,
                        buttons: ['OK'],
                    });
                await alert.present();

            },
            async loadData(page,search) {
                this.pageCount = page;
                
                const data = {
                    'page': page + 1,
                    // 'search':search,
                    'device_id':search['deviceId'],
                    'device_serial':search['deviceSerial'],
                    'username': window.localStorage.username,
                    'password': window.localStorage.password,
                };
                this.loading = true;
                this.$http.post('myGpsDevice', data).then(response => {
                    // const rows=[];
                    this.perPage = response.data.per_page;
                    this.total = response.data.total;
                    const gpsDevices = [];
                    for (const gpsDevice of response.data.data) {
                        let simsStr = "";
                        for (const sim of gpsDevice.sims) {
                            simsStr += "Slot " + sim.pivot.slot + ": " + sim.phone_number + "<br>";
                        }
                        let imei = "Slot 1: " + gpsDevice.slot1_imei_number;
                        if (gpsDevice.slot2_imei_number != null) {
                            imei += "<br>Slot 2: " + gpsDevice.slot2_imei_number;
                        }
                        gpsDevices.push({
                            serial: gpsDevice.serial,
                            id: gpsDevice.id,
                            sims: simsStr,
                            imei: imei,
                            version: gpsDevice.version,
                            gpsCompany: gpsDevice.gps_company,
                            createdBy: gpsDevice.created_by.name,
                            status: gpsDevice.status
                        });
                    }
                    this.gpsDevices = gpsDevices;
                    this.loading = false;
                });

            },
            onPage(event) {
                this.loadData(event.page,this.searchData);
            },
            transfer() {
                if (this.selectedDevices.length == 0) {
                    this.presentAlert("No device seleted!");
                    return;
                }
                const serials = [];
                for (const d of this.selectedDevices) {
                    serials.push(d.serial);
                }
                this.$router.push('/gps-device-transfer/' + JSON.stringify(serials));
            },
            changeStatus(event, id) {
                const data = {
                    'gps_device_id': id,
                    status: event.value,
                    username: window.localStorage.username,
                    password: window.localStorage.password,
                }
                this.$http.post('gpsDeviceChangeStatus', data).then(response => {
                    if (response.status == 200) {
                        for (const i in this.gpsDevices) {
                            // console.log(this.gpsDevices[i]);
                            if (this.gpsDevices[i].id == id) {
                                this.gpsDevices[i].status = event.value;
                            }
                        }
                        this.presentResponseAlert('Success',
                            'GPS Device\'s Status Changed successfully');
                    }
                }).catch(error =>{
                    console.log(error);
                });
            },
            async cancelSearch(){
                setTimeout(()=>{
                    if(this.searchData['deviceSerial'] == '' && this.searchData['deviceId'] == ''){
                        this.loadData(0,this.searchData);
                    }
                },350)
                
            },
            async presentAlert(message) {
                const alert = await alertController
                    .create({
                        header: 'Alert!',
                        // subHeader: 'Subtitle',
                        message: message,
                        buttons: ['OK'],
                    });
                await alert.present();

            },
            openPopover(e) {
                this.event = e;
                this.popoverOpen = true;
            },
        },
        
    });
</script>

<style>
    /* .dataRow:nth-child(even){
    background-color: #f2f2f2 !important;
} */
</style>